// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2egYt","rootSuccess":"CompleteLink_rootSuccess__2RagY","rootFailure":"CompleteLink_rootFailure__2EoaX","isDisabled":"CompleteLink_isDisabled__-OIF_"};